export default __webpack_public_path__ + "static/media/userManagement.cd94c7ad.svg";